import type { AllRouteEndpoints } from "../routeTypes";

export const engagementApprovalsContextIdStep = "/engagement/approvals/:context_id/(:step)";

export const engagementApprovalsContextIdStepCacheKeys: AllRouteEndpoints[] = [
  "/engagement/approvals/:context_id/(:step)",
  "/engagement/approvals/:context_id/:step",
];
